<ng-container *ngIf="message && message.message">
  <div class="d-block font-size-14 fw-light" [ngClass]="{'text-right': message.sender == 'remote'}">
    <div class="mb-2" *ngFor="let line of message.message.split('\n')">{{line}}</div>
  </div>
</ng-container>
